// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";

// import { directAndKmpApi } from "../../../api/DirectorAndKmp";

// // ── Security Holding Columns ──────────────────────────────────────────────────
// const SECURITY_COLUMNS = [
//   { key: "serialNumber",                          label: "S.No",                               col: "(1)"  },
//   { key: "companyName",                           label: "Name of the Company",                col: "(2)"  },
//   { key: "numberOfSecurities",                    label: "No. of Securities",                  col: "(3)"  },
//   { key: "descriptionOfSecurities",               label: "Description of Securities",          col: "(4)"  },
//   { key: "nominalValueOfSecurities",              label: "Nominal Value",                      col: "(5)"  },
//   { key: "dateOfAcquisition",                     label: "Date of Acquisition",                col: "(6)"  },
//   { key: "pricePaidForAcquisition",               label: "Price Paid (Acquisition)",           col: "(7)"  },
//   { key: "otherConsiderationPaidForAcquisition",  label: "Other Consideration (Acquisition)",  col: "(8)"  },
//   { key: "dateOfDisposal",                        label: "Date of Disposal",                   col: "(9)"  },
//   { key: "priceReceivedOnDisposal",               label: "Price Received (Disposal)",          col: "(10)" },
//   { key: "otherConsiderationReceivedOnDisposal",  label: "Other Consideration (Disposal)",     col: "(11)" },
//   { key: "cumulativeBalanceAfterTransaction",     label: "Cumulative Balance",                 col: "(12)" },
//   { key: "modeOfAcquisition",                     label: "Mode of Acquisition",                col: "(13)" },
//   { key: "modeOfHolding",                         label: "Mode of Holding",                    col: "(14)" },
//   { key: "pledgedOrEncumbered",                   label: "Pledged / Encumbered",               col: "(15)" },
// ];

// const SEC_PART_ONE = SECURITY_COLUMNS.slice(0, 8);
// const SEC_PART_TWO = [SECURITY_COLUMNS[0], ...SECURITY_COLUMNS.slice(8)];

// const BLANK_SECURITY = () => ({
//   id: Date.now() + Math.random(),
//   serialNumber: "", companyName: "", numberOfSecurities: "",
//   descriptionOfSecurities: "", nominalValueOfSecurities: "",
//   dateOfAcquisition: "", pricePaidForAcquisition: "",
//   otherConsiderationPaidForAcquisition: "", dateOfDisposal: "",
//   priceReceivedOnDisposal: "", otherConsiderationReceivedOnDisposal: "",
//   cumulativeBalanceAfterTransaction: "", modeOfAcquisition: "",
//   modeOfHolding: "", pledgedOrEncumbered: "false",
// });

// const fmt = (key, val) => {
//   if (val === null || val === undefined || val === "") return "—";
//   if (typeof val === "boolean") return val ? "Yes" : "No";
//   return String(val);
// };

// // ── Row: aligned label + value ───────────────────────────────────────────────
// const Row = ({ label, value }) => (
//   <div className="grid grid-cols-[160px_1fr] items-start gap-x-3 py-1.5 border-b border-slate-100 last:border-0">
//     <span className="text-[11px] font-semibold text-slate-500 leading-snug shrink-0">{label}</span>
//     <span className="text-[11px] text-slate-800 leading-snug break-words">
//       {value || <span className="text-slate-300">—</span>}
//     </span>
//   </div>
// );

// // ── Security SubTable ─────────────────────────────────────────────────────────
// const SubTable = ({ columns, data, partLabel }) => (
//   <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden">
//     <div className="bg-slate-100 border-b border-slate-200 px-4 py-1.5">
//       <span className="text-[11px] font-bold text-slate-600 uppercase tracking-widest">{partLabel}</span>
//     </div>
//     <div className="overflow-x-auto">
//       <table className="w-full text-[10px] border-collapse">
//         <thead>
//           <tr className="bg-slate-800 text-white">
//             {columns.map(col => (
//               <th key={col.key} className="border border-slate-600 px-2 py-1 text-center font-bold text-[9px] whitespace-nowrap">
//                 {col.col}
//               </th>
//             ))}
//           </tr>
//           <tr className="bg-slate-700 text-white">
//             {columns.map(col => (
//               <th key={col.key}
//                 className="border border-slate-600 px-2 py-2 text-center font-semibold text-[9px] leading-tight"
//                 style={{ minWidth: col.key === "serialNumber" ? 36 : 100 }}>
//                 {col.label}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((row, i) => (
//             <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}>
//               {columns.map(col => (
//                 <td key={col.key} className="border border-slate-200 px-2 py-1.5 text-center text-[10px] align-middle">
//                   {fmt(col.key, row[col.key])}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// // ── Director Card ─────────────────────────────────────────────────────────────
// const DirectorCard = ({ record, index }) => {
//   const p         = record.directorKmpPersonalDetails || {};
//   const present   = record.residentialAddress?.present   || {};
//   const permanent = record.residentialAddress?.permanent || {};

//   return (
//     <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden">
//       {/* Card Header */}
//      <div className="bg-primary pl-3">
//     <p className="font-semibold text-xs">{p.presentFullName || "—"}</p>
//     <p className="text-[9px] ">
//       {p.occupation || ""}
//       {p.directorIdentificationNumber
//         ? ` · DIN: ${p.directorIdentificationNumber}`
//         : ""}
//     </p>
  
// </div>

//       <div className="p-2 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2">

//         {/* ── Personal Details ── */}
//         <div>
//           <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pb-1 border-b border-slate-200">
//             Personal Details
//           </p>
//           <Row label="DIN"                         value={p.directorIdentificationNumber} />
//           <Row label="Present Name"                value={p.presentFullName} />
//           <Row label="Former Name"                 value={p.formerFullName} />
//           <Row label="Father's Name"               value={p.fathersName} />
//           <Row label="Mother's Name"               value={p.mothersName} />
//           <Row label="Spouse's Name"               value={p.spousesName} />
//           <Row label="Date of Birth"               value={p.dateOfBirth} />
//           <Row label="Nationality"                 value={p.nationality} />
//           <Row label="Occupation"                  value={p.occupation} />
//           <Row label="Board Resolution Date"       value={p.boardResolutionDate} />
//           <Row label="Appointment Date"            value={p.appointmentDate} />
//           <Row label="Cessation Date"              value={p.cessationDate} />
//           <Row label="Cessation Reason"            value={p.cessationReason} />
//           <Row label="PAN"                         value={p.permanentAccountNumber} />
//           <Row label="ICSI Membership No."         value={p.icsimembershipNumber} />
//           <Row label="Other Directorships / KMP"   value={p.otherDirectorshipsOrKmpPositions} />
//         </div>

//         {/* ── Residential Address ── */}
//         <div>
//           <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 pb-1 border-b border-slate-200">
//             Residential Address
//           </p>

//           {/* Present */}
//           <div className="mb-2">
//             <p className="text-[10px] font-black text-blue-500 uppercase tracking-wide mb-1">
//               Present Address
//             </p>
//             <div className="bg-blue-50 border border-blue-100 rounded-lg px-3 py-1">
//               <Row label="Address"  value={present.address} />
//               <Row label="City"     value={present.city} />
//               <Row label="District" value={present.district} />
//               <Row label="State"    value={present.state} />
//               <Row label="Pincode"  value={present.pincode} />
//               <Row label="Country"  value={present.country} />
//             </div>
//           </div>

//           {/* Permanent */}
//           <div>
//             <p className="text-[10px] font-black text-emerald-600 uppercase tracking-wide mb-1">
//               Permanent Address
//             </p>
//             <div className="bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-1">
//               <Row label="Address"  value={permanent.address} />
//               <Row label="City"     value={permanent.city} />
//               <Row label="District" value={permanent.district} />
//               <Row label="State"    value={permanent.state} />
//               <Row label="Pincode"  value={permanent.pincode} />
//               <Row label="Country"  value={permanent.country} />
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// // ── Add Security Modal (security entries only) ────────────────────────────────
// const AddSecurityModal = ({ onClose, onSave, saving, records }) => {
//   const [selectedRecordId, setSelectedRecordId] = useState(records[0]?.id || "");
//   const [securities, setSecurities]             = useState([BLANK_SECURITY()]);

//   const addSecurity    = () => setSecurities(prev => [...prev, BLANK_SECURITY()]);
//   const removeSecurity = (id) => setSecurities(prev => prev.length > 1 ? prev.filter(s => s.id !== id) : prev);
//   const setSecField    = (id, key, val) =>
//     setSecurities(prev => prev.map(s => s.id === id ? { ...s, [key]: val } : s));

//   const inputCls = "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400";
//   const labelCls = "block text-[10px] font-semibold text-gray-500 mb-0.5";

//   const handleSave = () => {
//     const payload = securities
//       .filter(s => s.companyName)
//       .map(s => ({
//         serialNumber:                          s.serialNumber ? parseInt(s.serialNumber, 10) : null,
//         companyName:                           s.companyName || "",
//         numberOfSecurities:                    s.numberOfSecurities ? parseInt(s.numberOfSecurities, 10) : null,
//         descriptionOfSecurities:               s.descriptionOfSecurities || "",
//         nominalValueOfSecurities:              s.nominalValueOfSecurities ? parseFloat(s.nominalValueOfSecurities) : null,
//         dateOfAcquisition:                     s.dateOfAcquisition || null,
//         pricePaidForAcquisition:               s.pricePaidForAcquisition ? parseFloat(s.pricePaidForAcquisition) : null,
//         otherConsiderationPaidForAcquisition:  s.otherConsiderationPaidForAcquisition || null,
//         dateOfDisposal:                        s.dateOfDisposal || null,
//         priceReceivedOnDisposal:               s.priceReceivedOnDisposal ? parseFloat(s.priceReceivedOnDisposal) : null,
//         otherConsiderationReceivedOnDisposal:  s.otherConsiderationReceivedOnDisposal || null,
//         cumulativeBalanceAfterTransaction:     s.cumulativeBalanceAfterTransaction ? parseFloat(s.cumulativeBalanceAfterTransaction) : null,
//         modeOfAcquisition:                     s.modeOfAcquisition || "",
//         modeOfHolding:                         s.modeOfHolding || "",
//         pledgedOrEncumbered:                   s.pledgedOrEncumbered === "true" || s.pledgedOrEncumbered === true,
//       }));
//     onSave(selectedRecordId, payload);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
//         <div className="bg-primary text-white px-6 py-3 rounded-t-xl flex justify-between items-center">
//           <h2 className="font-bold text-sm uppercase tracking-widest">Add Security Entries</h2>
//           <button onClick={onClose} className="text-white hover:text-red-300 text-xl font-bold">x</button>
//         </div>

//         <div className="overflow-y-auto p-4 flex-1 space-y-4">
//           {/* Director selector */}
//           {records.length > 1 && (
//             <div>
//               <label className="block text-xs font-semibold text-gray-600 mb-1">Select Director / KMP</label>
//               <select
//                 value={selectedRecordId}
//                 onChange={e => setSelectedRecordId(e.target.value)}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400"
//               >
//                 {records.map((r, i) => (
//                   <option key={r.id} value={r.id}>
//                     {r.directorKmpPersonalDetails?.presentFullName || `Director ${i + 1}`}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           )}

//           {/* Security rows */}
//           <div>
//             <div className="flex justify-between items-center mb-2">
//               <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Security Transactions</p>
//               <button onClick={addSecurity}
//                 className="text-[10px] bg-primary text-white px-3 py-1 rounded font-bold uppercase hover:bg-blue-700 transition">
//                 + Add Row
//               </button>
//             </div>

//             {securities.map((sec, idx) => (
//               <div key={sec.id} className="p-3 bg-slate-50 border border-slate-200 rounded-lg mb-3">
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-[10px] font-bold text-slate-400 uppercase">Row #{idx + 1}</span>
//                   {securities.length > 1 && (
//                     <button onClick={() => removeSecurity(sec.id)}
//                       className="text-[10px] text-red-500 hover:text-red-700 font-bold uppercase">
//                       Remove
//                     </button>
//                   )}
//                 </div>
//                 <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
//                   {[
//                     { key: "serialNumber",                         label: "S.No",                        type: "number" },
//                     { key: "companyName",                          label: "Company Name" },
//                     { key: "numberOfSecurities",                   label: "No. of Securities",           type: "number" },
//                     { key: "descriptionOfSecurities",              label: "Description" },
//                     { key: "nominalValueOfSecurities",             label: "Nominal Value",               type: "number" },
//                     { key: "dateOfAcquisition",                    label: "Date of Acquisition",         type: "date" },
//                     { key: "pricePaidForAcquisition",              label: "Price Paid (Acq.)",           type: "number" },
//                     { key: "otherConsiderationPaidForAcquisition", label: "Other Consideration (Acq.)" },
//                     { key: "dateOfDisposal",                       label: "Date of Disposal",            type: "date" },
//                     { key: "priceReceivedOnDisposal",              label: "Price Received (Disp.)",      type: "number" },
//                     { key: "otherConsiderationReceivedOnDisposal", label: "Other Consideration (Disp.)" },
//                     { key: "cumulativeBalanceAfterTransaction",    label: "Cumulative Balance",          type: "number" },
//                     { key: "modeOfAcquisition",                    label: "Mode of Acquisition" },
//                     { key: "modeOfHolding",                        label: "Mode of Holding" },
//                   ].map(f => (
//                     <div key={f.key}>
//                       <label className={labelCls}>{f.label}</label>
//                       <input type={f.type || "text"} value={sec[f.key] || ""}
//                         onChange={e => setSecField(sec.id, f.key, e.target.value)}
//                         className={inputCls} />
//                     </div>
//                   ))}
//                   <div>
//                     <label className={labelCls}>Pledged / Encumbered</label>
//                     <div className="flex gap-4 mt-1.5">
//                       {["true", "false"].map(val => (
//                         <label key={val} className="flex items-center gap-1 text-xs cursor-pointer">
//                           <input type="radio" name={"pledge-" + sec.id} value={val}
//                             checked={String(sec.pledgedOrEncumbered) === val}
//                             onChange={() => setSecField(sec.id, "pledgedOrEncumbered", val)}
//                             className="accent-primary" />
//                           {val === "true" ? "Yes" : "No"}
//                         </label>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="px-6 py-3 border-t flex justify-end gap-3">
//           <button onClick={onClose}
//             className="px-4 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 font-semibold uppercase">
//             Cancel
//           </button>
//           <button onClick={handleSave} disabled={saving}
//             className="px-4 py-2 text-xs bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-400 font-semibold uppercase">
//             {saving ? "Saving..." : "Save Securities"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ── Print styles ──────────────────────────────────────────────────────────────
// const PRINT_STYLES = `
//   @media print {
//     @page { size: A3 landscape; margin: 8mm; }
//     body * { visibility: hidden !important; }
//     #dirkmp-pdf-area, #dirkmp-pdf-area * { visibility: visible !important; }
//     #dirkmp-pdf-area { position: fixed; top: 0; left: 0; width: 100%; }
//   }
// `;

// // ── Main Viewer ───────────────────────────────────────────────────────────────
// const DirectorAndKmpViewer = ({ selectedClientData }) => {
//   const token     = useSelector((state) => state.auth?.access_token);
//   const accountId = selectedClientData?.accountId || selectedClientData?.id;

//   const [data,          setData]          = useState([]);
//   const [loading,       setLoading]       = useState(false);
//   const [showModal,     setShowModal]     = useState(false);
//   const [error,         setError]         = useState(null);
//   const [saving,        setSaving]        = useState(false);
//   const [status,        setStatus]        = useState(null);
//   const [generatingPdf, setGeneratingPdf] = useState(false);

//   useEffect(() => {
//     const style = document.createElement("style");
//     style.id = "dirkmp-print-style";
//     style.innerHTML = PRINT_STYLES;
//     if (!document.getElementById("dirkmp-print-style")) document.head.appendChild(style);
//     return () => document.getElementById("dirkmp-print-style")?.remove();
//   }, []);

//   useEffect(() => {
//     if (accountId && token) fetchData();
//   }, [accountId, token]);

//   const fetchData = async () => {
//     if (!accountId || !token) return;
//     setLoading(true);
//     setError(null);
//     try {
//       const res  = await directAndKmpApi.fetchDirectAndKmpRegister(accountId, token);
//       const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
//       setData(list);
//     } catch (err) {
//       setError(err.message || "Failed to load data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSaveSecurities = async (recordId, securityPayload) => {
//     setSaving(true);
//     setStatus(null);
//     try {
//       await directAndKmpApi.addNewDirANdKmpEntry( recordId, securityPayload, token);
//       setShowModal(false);
//       setStatus({ type: "success", message: "Security entries saved successfully!" });
//       fetchData();
//     } catch (err) {
//       setStatus({ type: "error", message: err.message || "Failed to save security entries." });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDownloadPdf = () => {
//     setGeneratingPdf(true);
//     setTimeout(() => { window.print(); setGeneratingPdf(false); }, 300);
//   };

//   const allSecurityRows = data.flatMap(rec => rec.securityHoldingTransactions || []);

//   const PrintSubTable = ({ columns, rows, partLabel }) => (
//     <div style={{ marginBottom: 12 }}>
//       <div style={{ fontWeight: "bold", fontSize: 12, color: "#000", marginBottom: 4, textTransform: "uppercase", letterSpacing: 1 }}>
//         {partLabel}
//       </div>
//       <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, color: "#000" }}>
//         <thead>
//           <tr style={{ background: "#000" }}>
//             {columns.map(col => (
//               <th key={col.key} style={{ border: "1px solid #000", padding: "2px 3px", textAlign: "center", fontSize: 12, whiteSpace: "nowrap", color: "#000" }}>
//                 {col.col}
//               </th>
//             ))}
//           </tr>
//           <tr style={{ background: "#000" }}>
//             {columns.map(col => (
//               <th key={col.key} style={{ border: "1px solid #000", padding: "2px 3px", textAlign: "center", fontSize: 10, lineHeight: 1.3, color: "#000", minWidth: 60 }}>
//                 {col.label}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {rows.map((row, i) => (
//             <tr key={i} style={{ background: "#000" }}>
//               {columns.map(col => (
//                 <td key={col.key} style={{ border: "1px solid #000", padding: "2px 3px", textAlign: "center", fontSize: 10, verticalAlign: "middle", color: "#000" }}>
//                   {fmt(col.key, row[col.key])}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );

//   return (
//     <div>
//       {/* Header */}
//       <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
//         <h1 className="text-2xl font-black uppercase tracking-tight">
//           Register of Directors and Key Managerial Personnel
//         </h1>
//         <h2 className="text-base font-bold mt-0.5">and their Shareholding</h2>
//         <p className="text-[10px] italic text-slate-500 mt-1 max-w-4xl mx-auto">
//           [Pursuant to section 88(1)(a) of the Companies Act, 2013 and rule 3(1) of the
//           Companies (Management and Administration) Rules, 2014]
//         </p>
//       </div>

//       {/* Controls */}
//       <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2 flex flex-wrap gap-3 items-center justify-between">
//         <div className="flex gap-2">
//           <button
//             onClick={() => { setShowModal(true); setStatus(null); }}
//             disabled={!accountId || data.length === 0}
//             className="bg-primary text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
//           >
//             + Add Security Entry
//           </button>
//           <button
//             onClick={handleDownloadPdf}
//             disabled={allSecurityRows.length === 0 || generatingPdf}
//             className="bg-green-600 text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
//           >
//             Download PDF
//           </button>
//         </div>
//         {data.length > 0 && (
//           <span className="text-xs text-slate-500">
//             <span className="font-bold text-slate-700">{data.length}</span> Director / KMP
//             &nbsp;·&nbsp;
//             <span className="font-bold text-slate-700">{allSecurityRows.length}</span> Security Transactions
//           </span>
//         )}
//       </div>

//       {/* Status Banner */}
//       {status && (
//         <div className={"mb-2 px-4 py-3 rounded-lg text-sm font-medium border " + (
//           status.type === "success"
//             ? "bg-green-50 text-green-800 border-green-200"
//             : "bg-red-50 text-red-800 border-red-200"
//         )}>
//           {status.message}
//         </div>
//       )}

//       {/* Content */}
//       {loading ? (
//         <div className="text-center py-10 text-gray-500 text-sm animate-pulse">Loading...</div>
//       ) : error ? (
//         <div className="text-center py-10">
//           <div className="inline-flex flex-col items-center gap-2 bg-red-50 border border-red-200 rounded-xl px-8 py-6">
//             <span className="text-red-400 text-3xl">!</span>
//             <p className="text-red-700 text-sm font-semibold">{error}</p>
//             <button onClick={fetchData}
//               className="mt-1 text-xs bg-red-600 text-white px-4 py-1.5 rounded font-bold uppercase hover:bg-red-700 transition">
//               Retry
//             </button>
//           </div>
//         </div>
//       ) : data.length === 0 ? (
//         <div className="text-center py-10 text-gray-400 text-sm italic">
//           {accountId ? "No entries found for this company." : "Select a company to view records."}
//         </div>
//       ) : (
//         <div className="flex flex-col gap-4">

//           {/* Director/KMP Cards */}
//           {data.map((record, i) => (
//             <DirectorCard key={record.id || i} record={record} index={i} />
//           ))}

//           {/* Security Tables */}
//           {allSecurityRows.length > 0 && (
//             <>
//               <div className="bg-slate-800 text-white px-5 py-2.5 rounded-xl shadow-sm">
//                 <p className="font-bold text-xs uppercase tracking-widest">
//                   Details of Securities Held in the Company
//                 </p>
//               </div>
//               <SubTable
//                 columns={SEC_PART_ONE}
//                 data={allSecurityRows}
//                 partLabel="Part A — Security Transactions (Columns 1 to 8)"
//               />
//               <SubTable
//                 columns={SEC_PART_TWO}
//                 data={allSecurityRows}
//                 partLabel="Part B — Security Transactions (Columns 9 to 15)"
//               />
//             </>
//           )}

//           <div className="text-xs text-gray-400 text-right px-1 pb-2">
//             Total security transactions: <span className="font-bold text-gray-600">{allSecurityRows.length}</span>
//           </div>
//         </div>
//       )}

//       {/* Hidden PDF Print Area */}
//       {data.length > 0 && (
//         <div id="dirkmp-pdf-area" style={{ display: "none" }}>
//           <style>{"@media print { #dirkmp-pdf-area { display: block !important; } }"}</style>
//           <div style={{ textAlign: "center", marginBottom: 10, fontFamily: "Arial, sans-serif" }}>
//             <h1 style={{ fontSize: 16, fontWeight: "bold", margin: 0 }}>
//               Register of Directors and Key Managerial Personnel and their Shareholding
//             </h1>
//             <p style={{ fontSize: 13, margin: "2px 0 0", fontStyle: "italic", color: "#000" }}>
//               [Pursuant to section 88(1)(a) of the Companies Act, 2013]
//             </p>
//           </div>

//           {data.map((rec, i) => {
//             const p         = rec.directorKmpPersonalDetails || {};
//             const present   = rec.residentialAddress?.present   || {};
//             const permanent = rec.residentialAddress?.permanent || {};
//             return (
//               <div key={i} style={{ marginBottom: 14, fontFamily: "Arial, sans-serif", fontSize: 12, color: "#000" }}>
//                 <div style={{ fontWeight: "bold", fontSize: 13, background: "#1e3a5f", color: "#000", padding: "3px 6px", marginBottom: 3 }}>
//                   Director / KMP #{i + 1}: {p.presentFullName || "—"}
//                 </div>
//                 <table style={{  width: "100%", fontSize: 11 }}>
//                   <tbody>
//                     {[
//                       ["DIN", p.directorIdentificationNumber],
//                       ["Present Name", p.presentFullName],
//                       ["Father's Name", p.fathersName],
//                       ["Date of Birth", p.dateOfBirth],
//                       ["Nationality", p.nationality],
//                       ["Occupation", p.occupation],
//                       ["Appointment Date", p.appointmentDate],
//                       ["Cessation Date", p.cessationDate],
//                       ["PAN", p.permanentAccountNumber],
//                       ["Present Address", [present.address, present.city, present.state, present.pincode].filter(Boolean).join(", ")],
//                       ["Permanent Address", [permanent.address, permanent.city, permanent.state, permanent.pincode].filter(Boolean).join(", ")],
//                     ].map(([label, val]) => (
//                       <tr key={label}>
//                         <td style={{ border: "1px solid #ccc", padding: "2px 4px", fontWeight: "bold", width: "28%", background: "#f5f5f5", color: "#000" }}>{label}</td>
//                         <td style={{ border: "1px solid #ccc", padding: "2px 4px", color: "#000" }}>{val || "—"}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             );
//           })}

//           {allSecurityRows.length > 0 && (
//             <>
//               <PrintSubTable columns={SEC_PART_ONE} rows={allSecurityRows} partLabel="Security Transactions - Part A (Columns 1-8)" />
//               <div style={{ height: 10 }} />
//               <PrintSubTable columns={SEC_PART_TWO} rows={allSecurityRows} partLabel="Security Transactions - Part B (Columns 9-15)" />
//             </>
//           )}
//         </div>
//       )}

//       {showModal && (
//         <AddSecurityModal
//           onClose={() => setShowModal(false)}
//           onSave={handleSaveSecurities}
//           saving={saving}
//           records={data}
//         />
//       )}
//     </div>
//   );
// };

// export default DirectorAndKmpViewer;

import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { directAndKmpApi } from "../../../api/DirectorAndKmp";

// ── Security Holding Columns ──────────────────────────────────────────────────
const SECURITY_COLUMNS = [
  { key: "serialNumber",                          label: "S.No",                               col: "(1)"  },
  { key: "companyName",                           label: "Name of the Company",                col: "(2)"  },
  { key: "numberOfSecurities",                    label: "No. of Securities",                  col: "(3)"  },
  { key: "descriptionOfSecurities",               label: "Description of Securities",          col: "(4)"  },
  { key: "nominalValueOfSecurities",              label: "Nominal Value",                      col: "(5)"  },
  { key: "dateOfAcquisition",                     label: "Date of Acquisition",                col: "(6)"  },
  { key: "pricePaidForAcquisition",               label: "Price Paid (Acquisition)",           col: "(7)"  },
  { key: "otherConsiderationPaidForAcquisition",  label: "Other Consideration (Acquisition)",  col: "(8)"  },
  { key: "dateOfDisposal",                        label: "Date of Disposal",                   col: "(9)"  },
  { key: "priceReceivedOnDisposal",               label: "Price Received (Disposal)",          col: "(10)" },
  { key: "otherConsiderationReceivedOnDisposal",  label: "Other Consideration (Disposal)",     col: "(11)" },
  { key: "cumulativeBalanceAfterTransaction",     label: "Cumulative Balance",                 col: "(12)" },
  { key: "modeOfAcquisition",                     label: "Mode of Acquisition",                col: "(13)" },
  { key: "modeOfHolding",                         label: "Mode of Holding",                    col: "(14)" },
  { key: "pledgedOrEncumbered",                   label: "Pledged / Encumbered",               col: "(15)" },
];

const SEC_PART_ONE = SECURITY_COLUMNS.slice(0, 8);
const SEC_PART_TWO = [SECURITY_COLUMNS[0], ...SECURITY_COLUMNS.slice(8)];

// ── Blank entry (flat — matches form fields 1:1) ──────────────────────────────
const BLANK_ENTRY = {
  serialNumber:                         "",
  companyName:                          "",
  numberOfSecurities:                   "",
  descriptionOfSecurities:              "",
  nominalValueOfSecurities:             "",
  dateOfAcquisition:                    "",
  pricePaidForAcquisition:              "",
  otherConsiderationPaidForAcquisition: "",
  dateOfDisposal:                       "",
  priceReceivedOnDisposal:              "",
  otherConsiderationReceivedOnDisposal: "",
  cumulativeBalanceAfterTransaction:    "",
  modeOfAcquisition:                    "",
  modeOfHolding:                        "",
  pledgedOrEncumbered:                  "false",
};

const dateFields   = ["dateOfAcquisition", "dateOfDisposal"];
const numberFields = [
  "serialNumber", "numberOfSecurities", "nominalValueOfSecurities",
  "pricePaidForAcquisition", "priceReceivedOnDisposal",
  "cumulativeBalanceAfterTransaction",
];

// ── Helpers ───────────────────────────────────────────────────────────────────
const fmt = (key, val) => {
  if (val === null || val === undefined || val === "") return "—";
  if (typeof val === "boolean") return val ? "Yes" : "No";
  return String(val);
};

const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return "—"; }
};

// ── Row: aligned label + value ────────────────────────────────────────────────
const Row = ({ label, value }) => (
  <div className="grid grid-cols-[160px_1fr] items-start gap-x-3 py-1.5 border-b border-slate-100 last:border-0">
    <span className="text-[11px] font-semibold text-slate-500 leading-snug shrink-0">{label}</span>
    <span className="text-[11px] text-slate-800 leading-snug break-words">
      {value || <span className="text-slate-300">—</span>}
    </span>
  </div>
);

// ── Security SubTable ─────────────────────────────────────────────────────────
const SubTable = ({ columns, data, partLabel }) => (
  <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
    <div className="bg-slate-100 border-b border-slate-200 px-4 py-1.5">
      <span className="text-[11px] font-bold text-slate-600 uppercase tracking-widest">{partLabel}</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-[10px] border-collapse">
        <thead>
          <tr className="bg-slate-800 text-white">
            {columns.map(col => (
              <th key={col.key} className="border border-slate-600 px-2 py-1 text-center font-bold text-[9px] whitespace-nowrap">
                {col.col}
              </th>
            ))}
          </tr>
          <tr className="bg-slate-700 text-white">
            {columns.map(col => (
              <th key={col.key}
                className="border border-slate-600 px-2 py-2 text-center font-semibold text-[9px] leading-tight"
                style={{ minWidth: col.key === "serialNumber" ? 36 : 100 }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}>
              {columns.map(col => (
                <td key={col.key} className="border border-slate-200 px-2 py-1.5 text-center text-[10px] align-middle">
                  {dateFields.includes(col.key) ? fmtDate(row[col.key]) : fmt(col.key, row[col.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// ── Director Card (personal + address — no table) ─────────────────────────────
const DirectorCard = ({ record, index }) => {
  const p         = record.directorKmpPersonalDetails || {};
  const present   = record.residentialAddress?.present   || {};
  const permanent = record.residentialAddress?.permanent || {};

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
      {/* Card Header */}
      <div className="bg-primary text-white px-5 py-1 flex items-center gap-2">
    
          <p className="font-bold text-sm leading-tight">{p.presentFullName || "—"}</p>
          <p className="text-[10px] text-white/70 mt-0.5">
            {[p.occupation, p.directorIdentificationNumber ? `DIN: ${p.directorIdentificationNumber}` : ""].filter(Boolean).join(" · ")}
          </p>
        
      </div>

      <div className="p-2 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-3">

        {/* Personal Details */}
        <div>
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pb-1 border-b border-slate-200">
            Personal Details
          </p>
          <Row label="DIN"                       value={p.directorIdentificationNumber} />
          <Row label="Present Name"              value={p.presentFullName} />
          <Row label="Former Name"               value={p.formerFullName} />
          <Row label="Father's Name"             value={p.fathersName} />
          <Row label="Mother's Name"             value={p.mothersName} />
          <Row label="Spouse's Name"             value={p.spousesName} />
          <Row label="Date of Birth"             value={p.dateOfBirth} />
          <Row label="Nationality"               value={p.nationality} />
          <Row label="Occupation"                value={p.occupation} />
          <Row label="Board Resolution Date"     value={p.boardResolutionDate} />
          <Row label="Appointment Date"          value={p.appointmentDate} />
          <Row label="Cessation Date"            value={p.cessationDate} />
          <Row label="Cessation Reason"          value={p.cessationReason} />
          <Row label="PAN"                       value={p.permanentAccountNumber} />
          <Row label="ICSI Membership No."       value={p.icsimembershipNumber} />
          <Row label="Other Directorships / KMP" value={p.otherDirectorshipsOrKmpPositions} />
        </div>

        {/* Residential Address */}
        <div>
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pb-1 border-b border-slate-200">
            Residential Address
          </p>

          <div className="mb-4">
            <p className="text-[10px] font-black text-blue-500 uppercase tracking-wide mb-1.5">Present Address</p>
            <div className="bg-blue-50 border border-blue-100 rounded-lg px-3 py-1">
              <Row label="Address"  value={present.address} />
              <Row label="City"     value={present.city} />
              <Row label="District" value={present.district} />
              <Row label="State"    value={present.state} />
              <Row label="Pincode"  value={present.pincode} />
              <Row label="Country"  value={present.country} />
            </div>
          </div>

          <div>
            <p className="text-[10px] font-black text-emerald-600 uppercase tracking-wide mb-1.5">Permanent Address</p>
            <div className="bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-1">
              <Row label="Address"  value={permanent.address} />
              <Row label="City"     value={permanent.city} />
              <Row label="District" value={permanent.district} />
              <Row label="State"    value={permanent.state} />
              <Row label="Pincode"  value={permanent.pincode} />
              <Row label="Country"  value={permanent.country} />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

// ── Add Entry Modal — exact MBP-2 pattern ────────────────────────────────────
const AddEntryModal = ({ onClose, onSave, saving, parentRecords }) => {
  const [selectedParentId, setSelectedParentId] = useState(
    parentRecords.length === 1 ? parentRecords[0].id : ""
  );
  const [form, setForm] = useState({ ...BLANK_ENTRY });

  const inputCls = "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400";
  const labelCls = "block text-xs font-medium text-gray-600 mb-1";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">

        {/* Header */}
        <div className="bg-primary text-white px-6 py-3 rounded-t-xl flex justify-between items-center">
          <h2 className="font-bold text-sm uppercase tracking-widest">Add New Security Entry</h2>
          <button onClick={onClose} className="text-white hover:text-red-300 text-xl font-bold">✕</button>
        </div>

        <div className="overflow-y-auto p-4 flex-1">

          {/* Director / KMP selector — shown when multiple records */}
          {parentRecords.length > 1 && (
            <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <label className="block text-xs font-semibold text-blue-700 mb-1">Select Director / KMP *</label>
              <select
                value={selectedParentId}
                onChange={e => setSelectedParentId(e.target.value)}
                className="w-full px-2 py-1.5 border border-blue-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="">— Select —</option>
                {parentRecords.map((r, i) => (
                  <option key={r.id} value={r.id}>
                    {r.directorKmpPersonalDetails?.presentFullName || `Director ${i + 1}`}
                    {r.directorKmpPersonalDetails?.directorIdentificationNumber
                      ? ` · DIN: ${r.directorKmpPersonalDetails.directorIdentificationNumber}`
                      : ""}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Pledged field — highlighted separately like MBP-2's loan group */}
          <div className="mb-3 p-3 bg-amber-50 rounded-lg border border-amber-200">
            <p className="text-xs font-semibold text-amber-700 mb-2">Pledge / Encumbrance</p>
            <div className="flex gap-6">
              {["false", "true"].map(val => (
                <label key={val} className="flex items-center gap-2 text-xs cursor-pointer font-medium text-gray-700">
                  <input
                    type="radio"
                    name="pledgedOrEncumbered"
                    value={val}
                    checked={form.pledgedOrEncumbered === val}
                    onChange={() => setForm(prev => ({ ...prev, pledgedOrEncumbered: val }))}
                    className="accent-primary"
                  />
                  {val === "true" ? "Yes — Pledged / Encumbered" : "No — Not Pledged"}
                </label>
              ))}
            </div>
          </div>

          {/* All other fields — same grid as MBP-2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {SECURITY_COLUMNS.filter(c => c.key !== "serialNumber" && c.key !== "pledgedOrEncumbered").map(col => (
              <div key={col.key}>
                <label className={labelCls}>{col.col} {col.label}</label>
                <input
                  type={dateFields.includes(col.key) ? "date" : numberFields.includes(col.key) ? "number" : "text"}
                  value={form[col.key] || ""}
                  onChange={e => setForm(prev => ({ ...prev, [col.key]: e.target.value }))}
                  className={inputCls}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-3 border-t flex justify-end gap-3">
          <button onClick={onClose}
            className="px-4 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 font-semibold uppercase">
            Cancel
          </button>
          <button
            onClick={() => onSave(form, selectedParentId)}
            disabled={saving || !selectedParentId}
            className="px-4 py-2 text-xs bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed font-semibold uppercase"
          >
            {saving ? "Saving..." : "Save Entry"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Print styles ──────────────────────────────────────────────────────────────
const PRINT_STYLES = `
  @media print {
    @page { size: A3 landscape; margin: 8mm; }
    body * { visibility: hidden !important; }
    #dirkmp-pdf-area, #dirkmp-pdf-area * { visibility: visible !important; }
    #dirkmp-pdf-area { position: fixed; top: 0; left: 0; width: 100%; font-family: Arial, sans-serif; }
  }
`;

// ── Main Viewer ───────────────────────────────────────────────────────────────
const DirectorAndKmpViewer = ({ selectedClientData }) => {
  const token     = useSelector((state) => state.auth?.access_token);
  const accountId = selectedClientData?.accountId || selectedClientData?.id;

  const [data,          setData]          = useState([]);
  const [loading,       setLoading]       = useState(false);
  const [error,         setError]         = useState(null);
  const [showModal,     setShowModal]     = useState(false);
  const [saving,        setSaving]        = useState(false);
  const [status,        setStatus]        = useState(null);
  const [generatingPdf, setGeneratingPdf] = useState(false);

  // Inject print styles
  useEffect(() => {
    const style = document.createElement("style");
    style.id = "dirkmp-print-style";
    style.innerHTML = PRINT_STYLES;
    if (!document.getElementById("dirkmp-print-style")) document.head.appendChild(style);
    return () => document.getElementById("dirkmp-print-style")?.remove();
  }, []);

  // fetchData — useCallback exactly like MBP-2
  const fetchData = useCallback(async () => {
    if (!accountId || !token) return;
    setLoading(true);
    setError(null);
    try {
      const res  = await directAndKmpApi.fetchDirectAndKmpRegister(accountId, token);
      const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
      setData(list);
    } catch (err) {
      setError(err.message || "No data available.");
    } finally {
      setLoading(false);
    }
  }, [accountId, token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  // handleSaveEntry — flat form → structured payload → API call (MBP-2 pattern)
  const handleSaveEntry = async (form, parentId) => {
    setSaving(true);
    setStatus(null);
    try {
      const payload = {
        serialNumber:                          form.serialNumber ? parseInt(form.serialNumber, 10) : null,
        companyName:                           form.companyName || "",
        numberOfSecurities:                    form.numberOfSecurities ? parseInt(form.numberOfSecurities, 10) : null,
        descriptionOfSecurities:               form.descriptionOfSecurities || "",
        nominalValueOfSecurities:              form.nominalValueOfSecurities ? parseFloat(form.nominalValueOfSecurities) : null,
        dateOfAcquisition:                     form.dateOfAcquisition || null,
        pricePaidForAcquisition:               form.pricePaidForAcquisition ? parseFloat(form.pricePaidForAcquisition) : null,
        otherConsiderationPaidForAcquisition:  form.otherConsiderationPaidForAcquisition || null,
        dateOfDisposal:                        form.dateOfDisposal || null,
        priceReceivedOnDisposal:               form.priceReceivedOnDisposal ? parseFloat(form.priceReceivedOnDisposal) : null,
        otherConsiderationReceivedOnDisposal:  form.otherConsiderationReceivedOnDisposal || null,
        cumulativeBalanceAfterTransaction:     form.cumulativeBalanceAfterTransaction ? parseFloat(form.cumulativeBalanceAfterTransaction) : null,
        modeOfAcquisition:                     form.modeOfAcquisition || "",
        modeOfHolding:                         form.modeOfHolding || "",
        pledgedOrEncumbered:                   form.pledgedOrEncumbered === "true",
      };

      await directAndKmpApi.addNewDirANdKmpEntry(parentId, payload, token);
      setShowModal(false);
      setStatus({ type: "success", message: "Entry added successfully!" });
      await fetchData();
    } catch (err) {
      setStatus({ type: "error", message: err.message || "Failed to add entry." });
    } finally {
      setSaving(false);
    }
  };

  const handleDownloadPdf = () => {
    setGeneratingPdf(true);
    setTimeout(() => { window.print(); setGeneratingPdf(false); }, 300);
  };

  const allSecurityRows = data.flatMap(rec => rec.securityHoldingTransactions || []);

  if (!selectedClientData) {
    return <p className="text-center text-gray-500 mt-10">Select an account to view Director & KMP data.</p>;
  }

  // ── PDF sub-table ─────────────────────────────────────────────────────────
  const PdfSubTable = ({ columns, rows, partLabel }) => (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 12, fontWeight: "bold", color: "#000", marginBottom: 3, textTransform: "uppercase", letterSpacing: 0.8 }}>
        {partLabel}
      </div>
      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
        <thead>
          <tr style={{ background: "#000" }}>
            {columns.map(col => (
              <th key={col.key} style={{ border: "1px solid #555", padding: "2px 3px", textAlign: "center", fontSize: 12, whiteSpace: "nowrap", color: "#000" }}>
                {col.col}
              </th>
            ))}
          </tr>
          <tr style={{ background: "#000" }}>
            {columns.map(col => (
              <th key={col.key} style={{ border: "1px solid #555", padding: "3px", textAlign: "center", fontSize: 12, lineHeight: 1.3, minWidth: col.key === "serialNumber" ? 24 : 72, color: "#000" }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? "#000" : "#f8fafc" }}>
              {columns.map(col => (
                <td key={col.key} style={{ border: "1px solid #ccc", padding: "2px 3px", textAlign: "center", fontSize: 12, verticalAlign: "middle", color: "#000" }}>
                  {dateFields.includes(col.key) ? fmtDate(row[col.key]) : fmt(col.key, row[col.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div>
      {/* ── Page Header ── */}
      <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
        <h1 className="text-2xl font-black uppercase tracking-tight">
          Register of Directors and Key Managerial Personnel
        </h1>
        <h2 className="text-base font-bold mt-0.5">and their Shareholding</h2>
        <p className="text-[10px] italic text-slate-500 mt-1 max-w-4xl mx-auto">
          [Pursuant to section 88(1)(a) of the Companies Act, 2013 and rule 3(1) of the
          Companies (Management and Administration) Rules, 2014]
        </p>
      </div>

      {/* ── Controls ── */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2 flex flex-wrap gap-3 items-end justify-between">
        <div className="flex gap-2">
          <button
            onClick={() => { setShowModal(true); setStatus(null); }}
            disabled={!accountId}
            className="bg-primary text-white text-xs px-4 py-1 rounded-md font-bold uppercase shadow-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
          >
            + Add New Entry
          </button>
          <button
            onClick={fetchData}
            className="bg-primary text-white text-xs px-4 py-1 rounded-md font-bold uppercase shadow-sm hover:bg-blue-700 transition"
          >
            🔄 Reload
          </button>
          <button
            onClick={handleDownloadPdf}
            disabled={allSecurityRows.length === 0 || generatingPdf}
            className="bg-green-600 text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
          >
            ⬇ Download PDF
          </button>
        </div>
        {data.length > 0 && (
          <span className="text-xs text-slate-500">
            <span className="font-bold text-slate-700">{data.length}</span> Director / KMP
            &nbsp;·&nbsp;
            <span className="font-bold text-slate-700">{allSecurityRows.length}</span> Security Transactions
          </span>
        )}
      </div>

      {/* ── Status Banner ── */}
      {status && (
        <div className={`mb-2 px-4 py-3 rounded-lg text-sm font-medium border ${
          status.type === "success"
            ? "bg-green-50 text-green-800 border-green-200"
            : "bg-red-50 text-red-800 border-red-200"
        }`}>
          {status.message}
        </div>
      )}

      {/* ── Content ── */}
      {loading ? (
        <div className="text-center py-10 text-gray-500 text-sm animate-pulse">Loading...</div>
      ) : error ? (
        <div className="text-center py-10">
          <div className="inline-flex flex-col items-center gap-2 bg-red-50 border border-red-200 rounded-xl px-8 py-6">
            <span className="text-red-400 text-3xl">!</span>
            <p className="text-red-700 text-sm font-semibold">{error}</p>
            <button onClick={fetchData}
              className="mt-1 text-xs bg-red-600 text-white px-4 py-1.5 rounded font-bold uppercase hover:bg-red-700 transition">
              Retry
            </button>
          </div>
        </div>
      ) : data.length === 0 ? (
        <div className="text-center py-10 text-gray-400 text-sm italic">
          {accountId ? "No entries found for this company." : "Select a company to view records."}
        </div>
      ) : (
        <div className="flex flex-col gap-4">

          {/* Director / KMP cards — grouped like MBP-2 per-record sections */}
          {data.map((record, i) => {
            const secRows = record.securityHoldingTransactions || [];
            return (
              <div key={record.id || i} className="mb-6">

                {/* Director info card */}
                <DirectorCard record={record} index={i} />

                {/* Per-director security tables — like MBP-2's per-record tables */}
                {secRows.length > 0 && (
                  <>
                    <div className="mt-3">
                      <SubTable
                        columns={SEC_PART_ONE}
                        data={secRows}
                        partLabel="Security Transactions — Part A (Columns 1 to 8)"
                      />
                    </div>
                    <div className="mt-3">
                      <SubTable
                        columns={SEC_PART_TWO}
                        data={secRows}
                        partLabel="Security Transactions — Part B (Columns 9 to 15)"
                      />
                    </div>
                    <div className="text-right text-xs text-gray-500 mt-1 pr-1">
                      Security transactions for this director: <span className="font-bold text-gray-700">{secRows.length}</span>
                    </div>
                  </>
                )}
              </div>
            );
          })}

          <div className="text-right text-xs text-gray-500 mb-4 pr-1">
            Total security transactions: <span className="font-bold text-gray-700">{allSecurityRows.length}</span>
          </div>
        </div>
      )}

      {/* ── Hidden PDF Print Area ── */}
      {data.length > 0 && (
        <div id="dirkmp-pdf-area" style={{ display: "none" }}>
          <style>{`@media print { #dirkmp-pdf-area { display: block !important; } }`}</style>

          <div style={{ textAlign: "center", marginBottom: 10, fontFamily: "Arial, sans-serif" }}>
            <h1 style={{ fontSize: 15, fontWeight: "bold", margin: 0 }}>
              Register of Directors and Key Managerial Personnel and their Shareholding
            </h1>
            <p style={{ fontSize: 11, margin: "2px 0 0", fontStyle: "italic", color: "#000" }}>
              [Pursuant to section 88(1)(a) of the Companies Act, 2013]
            </p>
          </div>

          {data.map((rec, idx) => {
            const p         = rec.directorKmpPersonalDetails || {};
            const present   = rec.residentialAddress?.present   || {};
            const permanent = rec.residentialAddress?.permanent || {};
            const secRows   = rec.securityHoldingTransactions || [];
            return (
              <div key={rec.id || idx} style={{ marginBottom: 20, fontFamily: "Arial, sans-serif" }}>

                {/* Director info bar — once per record, like MBP-2 */}
                <div style={{ background: "#1e3a5f", color: "#000", padding: "4px 8px", marginBottom: 6, fontSize: 12, borderRadius: 3, display: "flex", flexWrap: "wrap", gap: 12 }}>
                  <span>Director / KMP #{idx + 1}: <b>{p.presentFullName || "—"}</b></span>
                  {p.directorIdentificationNumber && <span>DIN: <b>{p.directorIdentificationNumber}</b></span>}
                  {p.appointmentDate && <span>Appointed: <b>{p.appointmentDate}</b></span>}
                </div>

                <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, marginBottom: 10 }}>
                  <tbody>
                    {[
                      ["Present Name",       p.presentFullName],
                      ["Father's Name",      p.fathersName],
                      ["Date of Birth",      p.dateOfBirth],
                      ["Nationality",        p.nationality],
                      ["Occupation",         p.occupation],
                      ["Appointment Date",   p.appointmentDate],
                      ["Cessation Date",     p.cessationDate],
                      ["PAN",                p.permanentAccountNumber],
                      ["Present Address",    [present.address, present.city, present.state, present.pincode].filter(Boolean).join(", ")],
                      ["Permanent Address",  [permanent.address, permanent.city, permanent.state, permanent.pincode].filter(Boolean).join(", ")],
                    ].map(([label, val]) => (
                      <tr key={label}>
                        <td style={{ border: "1px solid #ccc", padding: "2px 4px", fontWeight: "bold", width: "28%", background: "#f5f5f5", color: "#000" }}>{label}</td>
                        <td style={{ border: "1px solid #ccc", padding: "2px 4px", color: "#000" }}>{val || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {secRows.length > 0 && (
                  <>
                    <PdfSubTable columns={SEC_PART_ONE} rows={secRows} partLabel="Security Transactions — Part A (Columns 1–8)" />
                    <div style={{ height: 8 }} />
                    <PdfSubTable columns={SEC_PART_TWO} rows={secRows} partLabel="Security Transactions — Part B (Columns 9–15)" />
                  </>
                )}

                {idx < data.length - 1 && (
                  <div style={{ borderTop: "1.5px dashed #94a3b8", marginTop: 14 }} />
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── Add Entry Modal ── */}
      {showModal && (
        <AddEntryModal
          onClose={() => setShowModal(false)}
          onSave={handleSaveEntry}
          saving={saving}
          parentRecords={data}
        />
      )}
    </div>
  );
};

export default DirectorAndKmpViewer;